import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import ProductCategoryService from 'domains/product-category/services/product-category-service'
import { ListGroup, ListGroupItem, UncontrolledCollapse } from 'reactstrap'

const propTypes = {
  fieldName                 : PropTypes.string,
  categories                : PropTypes.array,
  formik                    : PropTypes.object,
  selectedCategoryOnChanges : PropTypes.func,
  rootCategoryId            : PropTypes.number
}

const defaultProps = {
  fieldName                 : '',
  categories                : [],
  formik                    : {},
  selectedCategoryOnChanges : () => {},
  rootCategoryId            : 0
}

const ProductCategoryFilterField = ({
  fieldName,
  categories,
  formik,
  selectedCategoryOnChanges,
  rootCategoryId
}) => {

  // {
  //   0: { id: .., label: .., children: ... },
  //   1: { id: .., label: .., children: ... }
  // }
  const [ parentCategories, setParentCategories ] = useState({})

  // Represent currently active category based on the rootCateogryId
  const [ rootCategory, setRootCategory ] = useState({
    id       : null,
    children : []
  })


  // Group categories by parent
  useEffect(() => {
    if (categories.length === 0) return

    const parentCategories = ProductCategoryService.groupByParent(categories)
    setParentCategories(parentCategories)
    setRootCategory(parentCategories[rootCategoryId])
  }, [ rootCategoryId, categories ])

  const handleClickCategory = (event, category) => {
    const conditicategoryId = category.id
    selectedCategoryOnChanges(category.id)
    formik.setFieldValue(fieldName, conditicategoryId)

    // this is to prevent the previous size_ids being applied
    formik.setFieldValue('size_ids', '')
  }

  // parentCategory = { id: 1, label: Pakaian, parent_id: 1 }
  const recursiveRender = (parentCategory) => {
    // load the category from `parentCategories` (data store) to get children
    const category = parentCategories[ parentCategory.id ]

    // recursion base case
    const hasChildren = category.children.length > 0
    if (!hasChildren) return (
      <ListGroupItem
        action
        style={{ cursor: 'pointer' }}
        name={ fieldName }
        active={ formik.values[fieldName] == category.id }
        onClick={ (event) => handleClickCategory(event, category) }
      >
        { category.label }
      </ListGroupItem>
    )

    const collapseId = [ 'collapse', category.id ].join('')
    const toggler    = [ '#', collapseId ].join('')

    return (
      <>
        { /* This is the "parent" category's label */ }
        <ListGroupItem
          action
          className={ 'd-flex justify-content-between' }
          name={ fieldName }
          active={ formik.values[fieldName] == category.id }
        >
          <span
            className={ 'flex-fill' }
            onClick={ (event) => handleClickCategory(event, category) }
          >
            { category.label }
          </span>
          <i className='fas fa-chevron-down' id={ collapseId } style={{ cursor: 'pointer' }}/>
        </ListGroupItem>

        { /* Render the children inside a collapse */ }
        <UncontrolledCollapse toggler={ toggler } defaultOpen={ false }>
          {
            category.children.map((childCategory) => {
              const childCategoryAsParent = parentCategories[childCategory.id]
              return (
                <ListGroupItem
                  action
                  className={ 'py-1' }
                  tag='ul'
                  key={ `${childCategoryAsParent.label}-${childCategory.label}-${childCategory.id}` }
                >
                  { recursiveRender(childCategoryAsParent) }
                </ListGroupItem>
              )
            })
          }
        </UncontrolledCollapse>
      </>
    )
  }

  return (
    <>
      <div className='filter-title font-weight-bold'>
        { 'CATEGORY' }
      </div>
      {
        rootCategory.children.map((category) => (
          <ListGroup key={ `parent-category-list-group-${ category.id }` }>
            { recursiveRender(category) }
          </ListGroup>
        ))
      }
    </>
  )
}

ProductCategoryFilterField.propTypes    = propTypes
ProductCategoryFilterField.defaultProps = defaultProps

export default ProductCategoryFilterField
